import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=5dbc67b8&"
import script from "./NavTabs.vue?vue&type=script&lang=js&"
export * from "./NavTabs.vue?vue&type=script&lang=js&"
import style0 from "./tabs.less?vue&type=style&index=0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports